import { CheckCircleOutline } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

const BrandAITrainedBanner = () => (
    <Stack
        direction="row"
        alignItems="flex-start"
        spacing={2}
        sx={{
            p: 3,
            py: 2,
            borderRadius: '8px',
            border: '2px solid',
            borderColor: 'teal',
            backgroundColor: 'background.paper',
            width: 420,
            minWidth: 420,
            maxWidth: 420,
        }}
    >
        <CheckCircleOutline
            sx={{
                fontSize: 32,
                color: 'teal',
                flexShrink: 0,
            }}
        />
        <Stack spacing={0.5} flex={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'black' }}>
                    Brand Voice Applied
                </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: 'black' }}>
                Messages will now reflect your Brand Voice
            </Typography>
        </Stack>
    </Stack>
);

export default BrandAITrainedBanner;
